
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboard",
      function () {
        return require("private-next-pages/onboard/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onboard"])
      });
    }
  